import CoreBase from '../../../../services/engines/CoreBase';
import templateLoader from './TemplateLoader';
import templateParser from './TemplateParser';
import dataEnricher from './DataEnricher';
import htmlBuilder from './HtmlBuilder';

class InputRenderer extends CoreBase {
    _name = 'InputRenderer';

    /**
     * Renders a data note entry to an HTML string.
     * @param {object} entry - data note entry object
     * @returns {string|null}
     */
    render(entry) {
        if (!entry?.tid) return null;

        const note = templateLoader.load(entry.tid);
        if (!note) return null;

        const templateJson = templateParser.parse(note);
        if (!templateJson) return null;

        const result = dataEnricher.enrich(entry);
        if (!result) return null;

        const { enriched, settings } = result;

        return htmlBuilder.build(templateJson, enriched, settings);
    }
}

const inputRenderer = new InputRenderer();
export default inputRenderer;
